// Rutas raíz de la aplicación
import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { internetConnectionGuard } from './core/guards/internet-connection.guard';
import { landingRedirectGuard } from './core/guards/landing-redirect.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/cotizador',
    pathMatch: 'full',
  },
  {
    path: 'cotizador',
    canActivate: [authGuard],
    canActivateChild: [internetConnectionGuard],
    loadComponent: () =>
      import('./layouts/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent,
      ),
    loadChildren: () =>
      import('./features/quoter/quoter.routes').then((m) => m.quoterRoutes),
  },
  {
    // 404 global: redirigir a landing
    path: '**',
    canActivate: [landingRedirectGuard],
    loadComponent: () =>
      import('./layouts/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent,
      ),
  },
];
